<template>
  <div>
    <!-- 面包屑导航 -->
<!--    <el-breadcrumb separator-class="el-icon-arrow-right">-->
<!--      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>-->
<!--      <el-breadcrumb-item>费用列表</el-breadcrumb-item>-->
<!--    </el-breadcrumb>-->
    <!-- 卡片 -->
    <el-card class="box-card" style="margin: 0px; padding: 0px;">
      <!-- 搜索  新增-->
      <el-form
          :inline="false"
          :model="searchForm"
          ref="searchForRef"
          autocomplete="on">

        <el-row :gutter="24">
<!--          <el-col :span="8">-->
<!--            <shopCompanyTemp ref="shopCompanyTemp" @changeData="setshopId" ></shopCompanyTemp>-->
<!--          </el-col>-->
<!--          <el-col :span="4">-->
<!--            <el-link href="/Welcome">首页</el-link> > <el-link type="primary" href="/extrasFeeList">费用列表</el-link>-->
<!--          </el-col>-->
          <el-col :span="5">
            <el-form-item label="个人" size="small" label-width="80px">
              <el-input type="text" size="mini" v-model="searchForm.car_username" placeholder="请输入个人姓名" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="选择车辆" size="small">
              <el-select v-model="searchForm.car_id" allow-create filterable clearable placeholder="请选择车牌" >
                <el-option
                    v-for="item in carData"
                    :key="item.id"
                    :label="item.plate_number"
                    :value="item.id">

                </el-option>
              </el-select>
            </el-form-item>
<!--            <carListTemp ref="carListTemp" :carId="searchForm.car_id" @changeData="chooseCar"></carListTemp>&lt;!&ndash;车辆&ndash;&gt;-->
          </el-col>
          <el-col :span="1.5">
            <el-button size="small" type="success" @click="searchSubmit()">搜索</el-button>
          </el-col>
          <el-col :span="1.5">
             <el-button type="info" size="small" @click="searchRest()">重置</el-button>
          </el-col>
          <el-col :span="1.5">
            <el-button size="small" type="primary" @click="addData">新增</el-button>
          </el-col>
          <el-col :span="1.5">
            <el-button type="warning" size="small" @click="toExcel()">导出Excel</el-button>
          </el-col>
        </el-row>
      </el-form>

      <!-- 表格 -->
      <el-table
          ref="multipleTable"
          :data="tableLoadData"
          stripe
          border
          size="mini"
          :header-cell-style="{background:'#e5e5e5',color:'#333333'}"
          height="700px"
      >
<!--        <el-table-column-->
<!--            label="操作"-->
<!--            prop="id"-->
<!--            :show-overflow-tooltip='true' width="70px" align="center">-->
<!--          <template slot-scope="scope">-->
<!--            <div class="centerText">-->
<!--              <el-button type="warning" size="mini" icon="el-icon-edit" @click="handelEdit(scope.row)"></el-button>-->
<!--            </div>-->
<!--            <br />-->
<!--            <div class="centerText">-->
<!--              <el-button type="danger" size="mini" icon="el-icon-delete" @click="handelDel(scope.row)"></el-button>-->
<!--            </div>-->
<!--            </template>-->

<!--        </el-table-column>-->

<!--        <el-table-column-->
<!--            label="个人"-->
<!--            prop="name"-->
<!--            :show-overflow-tooltip='true' width="100px" align="center">-->

<!--        </el-table-column>-->

        <el-table-column label="各项费用统计" align="center">

          <template slot-scope="scope">
            <div class="centerText borderStyle">

              <el-descriptions title="" direction="vertical" :column="9" border size="mini">

                <el-descriptions-item label="个人">
                  <el-tag>{{scope.row.car_username}}</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="车辆台次">
                  {{scope.row.car_count }}
                </el-descriptions-item>
                <el-descriptions-item label="统计项目">
                  {{scope.row.project_count }}

                  个</el-descriptions-item>

                <el-descriptions-item label="应收">
                  {{scope.row.ysfee_sum}}
                </el-descriptions-item>
                <el-descriptions-item label="成本">
                  {{scope.row.cbfee_sum}}
                </el-descriptions-item>
                <el-descriptions-item label="利润">
                  {{scope.row.lrfee_sum}}
                </el-descriptions-item>
                <el-descriptions-item label="已收">
                  {{scope.row.yishoufee_sum}}
                </el-descriptions-item>
                <el-descriptions-item label="未收">
                  {{scope.row.wsfee_sum}}
                </el-descriptions-item>
                <el-descriptions-item label="费用 ⚙ 操作">
                  <div class="centerText">
                    <el-button type="warning" size="mini" icon="el-icon-edit" circle @click="handelEdit(scope.row)"></el-button>

                    <el-button type="danger" size="mini" icon="el-icon-delete" circle @click="handelDel(scope.row)"></el-button>
                  </div>
                </el-descriptions-item>
              </el-descriptions>
              <el-collapse v-model="activeNames">
                <el-collapse-item v-for="(item, index) in scope.row.fee_list" :key="index" :name="scope.$index+1">
                  <template slot="title">
                    <div class="centerText">

                      <el-tag type="success">{{ item.fee_type }}</el-tag>
                      <el-tag >{{item.car_username}}</el-tag>
                      <el-tag v-if="item.plate_number" type="info">{{item.plate_number}}</el-tag>
                      <el-tag v-if="item.allPerson" type="warning">{{item.allPerson}}</el-tag>
                      <el-tag v-if="item.vin" type="danger">{{item.vin}}</el-tag>
                      <el-tag v-if="item.fee_repayment.length>0">还款记录,共{{item.fee_repayment.length}}条</el-tag>
                      <el-tag type="success" style="position:absolute;right:100px; margin-top:8px">
                        <i class="el-icon-info"></i>
                        点击 展开 / 关闭
                      </el-tag>
                    </div>

                  </template>

                  <div class="centerText">
                    <el-descriptions title="" direction="vertical" :column="7" size="mini" border>
                      <el-descriptions-item label="费用名称">
                        <el-tag type="success">{{item.fee_type}}</el-tag>
                      </el-descriptions-item>
                      <el-descriptions-item label="个人">
                        <el-tag>{{ item.car_username }}</el-tag>
                      </el-descriptions-item>
                      <el-descriptions-item label="经办人">
                        {{item.op_name}}
                      </el-descriptions-item>
                      <el-descriptions-item label="车牌号">
                        {{!item.plate_number?'-':item.plate_number}}
                      </el-descriptions-item>
                      <el-descriptions-item label="所属人">
                        {{!item.allPerson?'-':item.allPerson}}
                      </el-descriptions-item>
                      <el-descriptions-item label="车架号">
                        {{!item.vin?'-':item.vin}}
                      </el-descriptions-item>


                      <el-descriptions-item label="操作">

                        <el-button type="primary" size="mini" @click="openRepayment(item)" title="添加还款记录"><i class="el-icon-circle-plus-outline"></i>还款记录</el-button>

                        <el-button type="danger" size="mini" icon="el-icon-delete" @click="handelDel(item)"></el-button>

                      </el-descriptions-item>
                      <el-descriptions-item label="应收">
                        {{item.ysfee}}
                      </el-descriptions-item>
                      <el-descriptions-item label="成本">
                        {{item.cbfee}}
                      </el-descriptions-item>
                      <el-descriptions-item label="利润">
                        {{item.lrfee}}
                      </el-descriptions-item>
                      <el-descriptions-item label="已收">
                        {{item.yishoufee}}
                      </el-descriptions-item>
                      <el-descriptions-item label="未收">
                        {{item.wsfee}}
                      </el-descriptions-item>
                      <el-descriptions-item label="备注">
                        {{item.remark}}
                      </el-descriptions-item>

                    </el-descriptions>

                  </div>
                </el-collapse-item>

              </el-collapse>


            </div>
          </template>
        </el-table-column>

      </el-table>

      <!-- 分页 -->
      <div class="block" style="margin-top:10px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 30,50, 100]"
          :page-size="limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>
    <!-- 新增编辑弹框 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="70%">
      <el-form :model="form" :rules="rules" ref="form" label-width="110px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="选择个人" size="small" required>
              <el-select v-model="form.car_username" clearable placeholder="请选择个人" filterable allow-create>
                <el-option
                    v-for="item in carUserName"
                    :key="item.value"
                    :label="item.label"
                    :value="item.label">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <carListTemp ref="carListTemp" :carId="form.car_id" @changeData="setcarInfo"></carListTemp><!--车辆-->
          </el-col>
          <el-col :span="8">
            <el-button style="margin-bottom: 10px" size="small" type="primary" @click="setFeeData">
              添加费用明细
            </el-button>
          </el-col>


        </el-row>
        <el-row :gutter="24" v-if="form.id">
          <el-col :span="24">
            <el-descriptions title="统计" direction="vertical" :column="7" border>
              <el-descriptions-item label="车辆台次">5</el-descriptions-item>
              <el-descriptions-item label="统计项目">10</el-descriptions-item>
              <el-descriptions-item label="应收">150000</el-descriptions-item>
              <el-descriptions-item label="成本">100000</el-descriptions-item>
              <el-descriptions-item label="利润">100000</el-descriptions-item>
              <el-descriptions-item label="已收">100000</el-descriptions-item>
              <el-descriptions-item label="未收">100000</el-descriptions-item>
            </el-descriptions>
            <br />
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24" align="left">

            <el-table
                :data="feeDataList"
                stripe border
                :header-cell-style="{background:'#e5e5e5',color:'#333333'}"
                show-summary
                height="450px"
                >
              <el-table-column width="50px" label="操作" align='center'>
                <template slot-scope="scope">
                  <el-button @click.native.prevent="deleteItem(scope.$index, scope.row)" type="danger" size="mini" icon="el-icon-delete" circle></el-button>
                </template>
              </el-table-column>

              <el-table-column label="所属人" prop="allPerson" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column label="车牌号" prop="plate_number" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column label="车架号" prop="vin" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column label="个人" prop="car_username" :show-overflow-tooltip='true'>
              </el-table-column>

              <el-table-column
                  prop="name"
                  label="费用类型"
                  :show-overflow-tooltip='true'
                  width="180px"
              >
                <template slot-scope="scope">
                <el-select v-model="scope.row.fee_type" clearable placeholder="请选择费用类型" filterable allow-create>
                  <el-option
                      v-for="item in feeTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
                </template>
              </el-table-column>
              <el-table-column label="费用名称" width="180px" :show-overflow-tooltip='true'>
                <template slot-scope="scope">

                    <el-input v-model="scope.row.name" ></el-input>

                </template>
              </el-table-column>
              <el-table-column
                  prop="name"
                  label="经办人"
                  width="180px"
                  :show-overflow-tooltip='true'
              >
                <template slot-scope="scope">
                  <el-select v-model="scope.row.jbrTypeId" clearable placeholder="请选择经办人" filterable allow-create>
                    <el-option
                        v-for="item in jbrTypeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                  prop="name"
                  label="姓名"
                  width="180px"
                  :show-overflow-tooltip='true'
              >
                <template slot-scope="scope">
                  <el-select v-model="scope.row.jbrxmTypeId" clearable placeholder="请选择姓名" filterable allow-create>
                    <el-option
                        v-for="item in jbrxmTypeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="应收" prop="ysfee" width="120px" :show-overflow-tooltip='true'>
                <template slot-scope="scope">

                    <el-input v-model="scope.row.ysfee" ></el-input>

                </template>
              </el-table-column>
              <el-table-column label="成本" prop="cbfee" width="120px" :show-overflow-tooltip='true'>
                <template slot-scope="scope">

                  <el-input v-model="scope.row.cbfee" ></el-input>

                </template>
              </el-table-column>
              <el-table-column label="利润" prop="lrfee" width="120px" :show-overflow-tooltip='true'>
                <template slot-scope="scope">

                  <el-input v-model="scope.row.lrfee" ></el-input>

                </template>
              </el-table-column>
              <el-table-column label="已收" prop="yishoufee" width="120px" :show-overflow-tooltip='true'>
                <template slot-scope="scope">

                  <el-input v-model="scope.row.yishoufee" ></el-input>

                </template>
              </el-table-column>
              <el-table-column label="未收" prop="wsfee" width="120px" :show-overflow-tooltip='true'>
                <template slot-scope="scope">

                  <el-input v-model="scope.row.wsfee" ></el-input>

                </template>
              </el-table-column>
              <el-table-column label="备注" width="180px" :show-overflow-tooltip='true'>
                <template slot-scope="scope">

                    <el-input type="textarea" v-model="scope.row.remark" :autosize="{ minRows: 2, maxRows: 3}"></el-input>

                </template>
              </el-table-column>

            </el-table>
          </el-col>
        </el-row>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reset_dialogForm('form')">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 费用详情 -->
    <el-dialog :title="title2" :visible.sync="dialogFormVisible2" width="70%">

      <el-descriptions title="车辆信息" direction="vertical" :column="5" border v-if="feeInfo.car_info">
        <el-descriptions-item label="车牌">
          {{feeInfo.car_info.plate_number}}
        </el-descriptions-item>
        <el-descriptions-item label="车架号">
          {{feeInfo.car_info.vin}}
        </el-descriptions-item>
        <el-descriptions-item label="车型">
          {{feeInfo.car_info.vehicle_type}}
        </el-descriptions-item>
        <el-descriptions-item label="发证日期">
          {{feeInfo.car_info.issue_date}}
        </el-descriptions-item>
        <el-descriptions-item label="注册日期">
          {{feeInfo.car_info.register_date}}
        </el-descriptions-item>

      </el-descriptions>
      <el-descriptions direction="vertical" :column="4" border>
        <el-descriptions-item label="所有人">
          {{feeInfo.shop_name}}
        </el-descriptions-item>
        <el-descriptions-item label="个人">
          {{feeInfo.car_username}}
        </el-descriptions-item>
        <el-descriptions-item label="手机号">
          {{feeInfo.mobile}}
        </el-descriptions-item>

      </el-descriptions>
      <br />
      <el-descriptions title="统计" direction="vertical" :column="7" border>
        <el-descriptions-item label="车辆台次">5</el-descriptions-item>
        <el-descriptions-item label="统计项目">10</el-descriptions-item>
        <el-descriptions-item label="应收">150000</el-descriptions-item>
        <el-descriptions-item label="成本">100000</el-descriptions-item>
        <el-descriptions-item label="利润">100000</el-descriptions-item>
        <el-descriptions-item label="已收">100000</el-descriptions-item>
        <el-descriptions-item label="未收">100000</el-descriptions-item>
      </el-descriptions>
      <br />
      <el-table
          :data="feeDataList"
          stripe border height="400px"
          :header-cell-style="{background:'#e5e5e5',color:'#333333'}"
          show-summary
          size="mini"
      >
        <el-table-column label="还款记录" width="180px" :show-overflow-tooltip='true' extend>
          <el-button type="primary" @click="innerVisible = true">还款记录</el-button>
        </el-table-column>
        <el-table-column label="所属人" prop="allPerson" width="180px" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column label="车牌号" prop="plate_number" width="110px" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column label="车架号" prop="vin" width="180px" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column label="个人" prop="car_username"width="90px" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column
            prop="name"
            label="费用类型"
            width="180px"
            :show-overflow-tooltip="true"
            >
          <template slot-scope="scope">
            <el-select v-model="scope.row.fee_type" clearable placeholder="请选择费用类型" filterable disabled>
              <el-option
                  v-for="item in feeTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
            prop="name"
            label="费用名称"
            width="100px"
            :show-overflow-tooltip="true"
            >
        </el-table-column>
        <el-table-column
            prop="ysfee"
            label="应收"
            width="100px"
            :show-overflow-tooltip="true"
           >
        </el-table-column>
        <el-table-column
            prop="cbfee"
            label="成本"
            width="180px"
            :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
            prop="lrfee"
            label="利润"
            width="180px"
            :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
            prop="yishoufee"
            label="已收"
            width="180px"
            :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
            prop="wsfee"
            label="未收"
            width="180px"
            :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
            prop="remark"
            label="备注"
            width="180px"
            :show-overflow-tooltip="true"
        >
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
        width="100%"
        style="margin: 0;padding: 0;"
        title="设置还款记录"
        :visible.sync="innerVisible"
        append-to-body>
      <el-table
          :data="feeDataList"
          stripe border height="400px"
          show-summary
          size="mini"
          :header-cell-style="{background:'#e5e5e5',color:'#333333'}"
      >
        <el-table-column
            label="操作" width="50px"
        >
          <template slot-scope="scope">
            <el-button type="danger" size="mini" icon="el-icon-delete" circle @click="handelDelRepay(scope.row)"></el-button>
          </template>
        </el-table-column>
        <el-table-column
            label="序号" width="50px"
        >
          <template slot-scope="scope">
            {{scope.$index +1 }}
          </template>
        </el-table-column>
        <el-table-column
            label="时间"
            :show-overflow-tooltip='true'
            width="150px"
        >
          <template slot-scope="scope">
            {{scope.row.pay_date | dateFormat}}
          </template>
        </el-table-column>
        <el-table-column
            prop="pay_money"
            label="还款金额"
            :show-overflow-tooltip='true'
        >

        </el-table-column>
        <el-table-column
            label="还款方式"
            :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            {{scope.row.pay_type | statusRePay}}
          </template>
        </el-table-column>
        <el-table-column
            label="付款人"
            :show-overflow-tooltip='true'
        >
        <template slot-scope="scope">
          {{scope.row.pay_account}}
        </template>
        </el-table-column>
        <el-table-column
            label="付款帐号"
            :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            {{scope.row.pay_account_number}}
          </template>
        </el-table-column>
        <el-table-column
            label="付款银行"
            prop="pay_bank"
            :show-overflow-tooltip='true'
        >

        </el-table-column>

        <el-table-column
            label="收款人"
            :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            {{scope.row.payee_account}}
          </template>
        </el-table-column>
        <el-table-column
            label="收款帐号"
            :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            {{scope.row.payee_account_number}}
          </template>
        </el-table-column>
        <el-table-column
            label="付款银行"
            :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            {{scope.row.payee_bank}}
          </template>
        </el-table-column>
        <el-table-column
            label="附件"
            :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <viewer style="z-index: 99999" >
                        <span>
                          <img :src="scope.row.file_url" min-width="20" height="20"/>
                        </span>
            </viewer>
          </template>

        </el-table-column>
        <el-table-column
            label="下载"
            :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <el-link type="primary" :href="scope.row.file_url" target="_blank"><i class="el-icon-download"></i> 文件下载预览</el-link>
          </template>
        </el-table-column>
      </el-table>
      <el-form :model="repaymentForm" status-icon :rules="repaymentRules" ref="repaymentForm" label-width="100px" class="demo-ruleForm">


        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="上传支付凭证" label-width="120px"  prop="file_url" style="margin-bottom: 0px">

              <el-upload class="uploader" :auto-upload="false" :show-file-list="false" drag :on-change="uploadFile" action="#" >
                <i class="el-icon-upload" v-if="file_url==''">
              <span class="fontStyle1">将支付凭证拖到此处，或
                <span class="fontStyle2">点击上传</span>
              </span>
                </i>
                <div class="uploaded" v-else :style="{'background-image': 'url(' + file_url + ')','width':'360px','height':'130px','background-size':'cover'}">
<span class="fontStyle3">
                <i class="el-icon-zoom-in" @click="openWin('../../static/typeImg.html?typeImage=' +file_url)">查看图片</i>
              <i class="el-icon-delete-solid" @click.stop="delImg">删除图片</i>
              <i class="el-icon-refresh-right" slot="trigger">重新上传</i>
</span>

                </div>

              </el-upload>

            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="file_url">
            <el-form-item label="文件URL : " style="margin-bottom: 0px">
              <el-link type="primary" :href="repaymentForm.file_url" target="_blank"><i class="el-icon-download"></i> 文件下载预览</el-link>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="还款方式" prop="pay_type">

              <el-select v-model="repaymentForm.pay_type" clearable placeholder="请选择还款方式" filterable size="mini">
                <el-option
                    v-for="item in rePayTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>

            </el-form-item>
          </el-col>
          <el-col :span="8">
        <el-form-item label="还款金额" prop="pay_money">
          <el-input type="text" v-model="repaymentForm.pay_money"  size="mini"></el-input>
        </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="还款时间" prop="pay_date">
              <el-date-picker v-model="repaymentForm.pay_date" type="datetime" size="mini"  placeholder="请选择开始时间"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="付款人" prop="pay_account">
              <el-input type="text" v-model="repaymentForm.pay_account" size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="付款帐号" prop="pay_account_number">
              <el-input type="text" v-model="repaymentForm.pay_account_number" size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="付款开户行" prop="pay_bank">
              <el-input type="text" v-model="repaymentForm.pay_bank" size="mini"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="收款人" prop="payee_account">
              <el-input type="text" v-model="repaymentForm.payee_account" size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收款帐号" prop="payee_account_number">
              <el-input type="text" v-model="repaymentForm.payee_account_number" size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收款开户行" prop="payee_bank">
              <el-input type="text" v-model="repaymentForm.payee_bank" size="mini"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
        <el-form-item>
          <el-button type="primary" @click="repaymentSubmitForm('repaymentForm')">提交</el-button>
          <el-button @click="reset_dialogForm('repaymentForm')">重置</el-button>
        </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
    <!-- 全局遮罩 图片上传 -->
    <el-dialog :visible.sync="dialogVisible" :modal="true" :close-on-click-modal="false" :close-on-press-escape="false" width="50%">
      <div class="loading-overlay">
        <div class="loading-spinner" style="font-size:30px;font-weight: bold">
          <i class="el-icon-upload"></i>
          图片上传ing
          <i class="el-icon-loading"></i>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import moment from 'moment';    //日期时间转换
  import shopCompanyTemp from "../common/shopCompanyTemp.vue";
  import carListTemp from "../common/carlistTemp.vue";
  import imgCompressUtil from "../../utils/imgCompressUtil";
  import table2excel from 'js-table2excel';
  import {getRepayStatus} from '../../utils/utils/index';
  export default {
    name: "extrasFeeList",
    components: {
      shopCompanyTemp,
      carListTemp
    },
    props: {},
    data() {
      return {
        activeNames: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10,11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
        carData:[], //车辆列表
        dialogVisible:false,
        isShowCar:false,
        // 搜索
        searchForm: {
          car_username:'',
          car_id:''
        },
        searchRules: {
          car_username: [
            { required: true, message: "请选择个人", trigger: "blur" },
          ],
        },
        typeData:[
          {
            id:1,
            name:'代表30天内到期'
          },
          {
            id:2,
            name:'全部'
          }],
        // 数据
        tableLoadData: [],
        limit: 10,
        page:1,// 当前页码
        total:0,//总条目数
        id: '',
        rules: {
          //allPerson:[{ required: true, message: "请输入所属人", trigger: "blur" }],
          fee:[{required: true, message: '请输入费用', trigger: 'blur' },
            {pattern:'([1-9]\\d*(\\.\\d*[1-9])?)|(0\\.\\d*[1-9])',message: '费用必须大于0',trigger: 'blur'}
          ],
        },
        dialogFormVisible: false,
        title: '',
        form: {
          plate_number:'',
          vin:'',
          car_id: "",
          allPerson: "",
          name: "", //收费项目
          fee: "",
          remark: "",
          mobile: "",
          car_username: '',
        },
        uploadImg: '',
        uploadDialog: false,
        feeDataList:[],
        dialogFormVisible2: false,
        title2: '',
        feeInfo:{},
        feeTypeList:[
          {
            value: '1',
            label: '车辆年审费用'
          },
          {
            value: '2',
            label: '车辆管理费'
          },
          {
            value: '3',
            label: '营运证年审'
          },
          {
            value: '4',
            label: '驾驶证年审'
          },
          {
            value: '5',
            label: '二级维护'
          },
          {
            value: '6',
            label: '从业资格证年审'
          },
          {
            value: '7',
            label: '车辆等级评定费'
          },
          {
            value: '8',
            label: '其他费用'
          },
        ],
        jbrTypeList:[
          {
            value: '1',
            label: '超管'
          },
          {
            value: '2',
            label: '财务'
          },
          {
            value: '3',
            label: '内勤'
          }
        ],
        jbrxmTypeList:[
          {
            value: '1',
            label: '张珊'
          },
          {
            value: '2',
            label: '李四'
          }
        ],
        carUserName:[
          // {
          //   value: '1',
          //   label: '张珊'
          // },
          // {
          //   value: '2',
          //   label: '李四'
          // }
        ],
        innerVisible: false,
        repaymentForm:{
          pay_type: '',
          pay_money: '',
          payee_account: '',
          payee_account_number: '',
          payee_bank: '',
          // payee_bank_name: '',
          pay_account: '',
          pay_account_number: '',
          pay_bank: '',
          // pay_bank_name: '',
          pay_date: new Date(),
          file_url:'',
          fee_list_id:''
        },
        repaymentRules:{
          pay_money:[{required: true, message: '请输入还款金额', trigger: 'blur' },
            {pattern:'([1-9]\\d*(\\.\\d*[1-9])?)|(0\\.\\d*[1-9])',message: '还款金额必须大于0',trigger: 'blur'}
          ],
          pay_type:[{ required: true, message: "请选择支付方式", trigger: "blur" }],
          // pay_account:[{ required: true, message: "请输入付款人", trigger: "blur" }],
          // pay_account_number:[{ required: true, message: "请输入付款帐号", trigger: "blur" }],
          // pay_bank:[{ required: true, message: "请输入付款银行", trigger: "blur" }],
          // payee_account:[{ required: true, message: "请输入收款人", trigger: "blur" }],
          // payee_account_number:[{ required: true, message: "请输入收款帐号", trigger: "blur" }],
          // payee_bank:[{ required: true, message: "请输入收款银行", trigger: "blur" }],
        },
        file_url:'',
        //还款方式
        rePayTypeList:[
          {
            value: '1',
            label: '银行卡',
          },
          {
            value: '2',
            label: '支付宝',
          },
          {
            value: '3',
            label: '微信',
          },
          {
            value: '4',
            label: '信用卡',
          },
          {
            value: '5',
            label: '现金',
          }
        ],

      };
    },
    created() {
      this.DataList();
      this.getCarData();
      this.getShopFeeOptionList(4);
    },
    mounted() {

    },
    filters: {
      statusFilter(status) {
        if (status == 1) {
          return "启用";
        } else if (status == 2) {
          return "禁用";
        }
      },
      statusRePay(pay_type) {
        return getRepayStatus(pay_type);
      },
      //时间格式化
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("yyyy-MM-DD HH:mm:ss");
      },

    },
    methods: {
      getCarData() {
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
      }
      this.$axios.getCarList(param).then(res=>{
        if(res.code == 200){
          //console.log(res.data.data);
          this.carData = res.data.data
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error=>{
        //console.log(error);
      })
    },
      setcarInfo(value){
        this.$set(this.form,'allPerson' , value.allPerson) //不用set 的形式，页面数据不更新
        this.form.plate_number = value.plate_number
        this.form.car_id = value.id
        this.form.vin = value.vin
        this.form.model = value.model
        this.form.issue_date = value.issue_date
        this.form.register_date = value.register_date
      },
      getTime (time) {
        var date = new Date(time)
        var y = date.getFullYear()
        var m = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
        var d = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
        return y + '-' + m + '-' + d
      },
      getTime2(time) {
        var date = new Date(time)
        var y = date.getFullYear()
        var m = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
        var d = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
        var h = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
        var mi = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
        var s = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();
        return y + '-' + m + '-' + d + ' ' + h +':'+ mi +':'+ s
      },
      setshopId(value){
        //this.form.plate_number = value
        this.searchForm.shop_id = value
      },
      chooseCar(value){
        console.log('chooseCar-value',value);
        this.isShowCar=true;
        this.searchForm.plate_number = value.plate_number
        this.searchForm.car_id = value.id
        this.searchForm.vin = value.vin
        this.searchForm.model = value.model
        this.searchForm.issue_date = value.issue_date
        this.searchForm.register_date = value.register_date
      },
      //接收子组件传过来的值
      chooseCarInfo(value){
        this.$set(this.form,'allPerson' , value.allPerson) //不用set 的形式，页面数据不更新
        this.searchForm.plate_number = value.plate_number
        this.searchForm.car_id = value.id
        this.searchForm.vin = value.vin
        this.searchForm.model = value.model
        this.searchForm.issue_date = value.issue_date
        this.searchForm.register_date = value.register_date
      },
      DataList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          page: this.page,
          pageSize: this.limit,
        }
        if(this.searchForm.car_username) param.car_username =  this.searchForm.car_username
        if(this.searchForm.car_id) param.car_id =  this.searchForm.car_id
        // if(this.searchForm.keyword) param.keyword =  this.searchForm.keyword
        // if(this.searchForm.start_time) param.start_time =  this.getTime(this.searchForm.start_time)
        // if(this.searchForm.end_time) param.end_time = this.getTime(this.searchForm.end_time)
        this.$axios.getShopFeeList(param).then(res=>{
          if(res.code == 200){
            this.tableLoadData = res.data.data
            this.total = res.data.total
          }
        }).catch(error=>{
          //console.log(error);
        })
      },
      // 设置每页条数
      handleSizeChange(newSize) {
        this.limit = newSize
        this.DataList()
      },
      // 分页跳转
      handleCurrentChange(newPage) {
        this.page = newPage
        this.DataList()
      },
      // 新增
      addData() {
        this.$router.push('extrasFeeAdd')
        // this.title = '新增'
        // this.form = {
        //   // role_name: '',
        // }
        // this.dialogFormVisible = true
      },
      handelEdit(index) {
        this.$router.push({
          path:'/extrasFeeAdd',
          query:{
            id:index.id
          }
        })
        // this.id = index.id
        //
        // this.title = '编辑'
        // this.form = {
        // }
        // this.dialogFormVisible = true
        // // this.form = {...row};
        // console.log('handelEdit-index',index);
        // this.form = JSON.parse(JSON.stringify(index))
      },

      reset_dialogForm(formName) {
        this.dialogFormVisible = false
        this.$nextTick(() => {
          this.$refs[formName].resetFields()
        })
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            const param = {
              company_id:sessionStorage.getItem('company_id'),
              access_token:sessionStorage.getItem('token'),
              feeDataList:this.feeDataList
            }
            if(this.id) param.id = this.form.id
            this.$axios.saveOtherFee(param).then(res =>{
              if(res.code == 200){
                this.DataList();
                this.$message.success(res.msg);
                this.dialogFormVisible = false;
              }else{
                this.$message.error(res.msg);
              }
            })
          }
        })
      },
      searchSubmit() {
        this.page = 1;
        this.DataList();
      },

      handelDel(e) {
        console.log('handelDel',e);
        this.$confirm('此操作将删除该费用记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            id: e.id,
            type: 1,
          }
          //console.log(param);
          this.$axios.delFeeShopFee(param).then(res=>{
            if(res.code == 200){
              this.$message.success(res.msg);
              this.DataList()
            }else{
              this.$message.error(res.msg);
            }
          }).catch(error=>{
            //console.log(error);
          })
        }).catch(() => {
          // 点击取消:不删除了
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
          this.DataList()
        });
        this.teamDialog = false
      },
      // 点击弹出当前的图片
      handelDialog(index) {
        this.uploadDialog = true
        this.uploadImg = index.row.file_url.local_file_path
      },

      //费用详情
      showFeeInfo(row) {
        this.title2 = '费用详情';
        this.dialogFormVisible2 = true;
        console.log('showFeeInfo',row);
        this.feeInfo = row;

      },

      searchRest(){
        window.location.reload();//重新加载
      },
      // 新增
      setFeeData() {
        let item = {
          'name':'',
          'fee_type':'',
          'jbr_type':'',
          'jbrxm_type':'',
          'ysfee':'',
          'cbfee':'',
          'lrfee':'',
          'yishoufee':'',
          'wsfee':'',
          'remark':'',
          'car_id':'',
          'allPerson':'',
          'plate_number':'',
          'vin':'',
          'car_username':''
        };
        if(this.addForm.car_id){
          item.car_id = this.addForm.car_id;
        }
        if(this.addForm.allPerson){
          item.allPerson = this.addForm.allPerson;
        }
        if(this.addForm.plate_number){
          item.plate_number = this.addForm.plate_number;
        }
        if(this.addForm.vin){
          item.vin = this.addForm.vin;
        }

        if(this.addForm.car_username){
          item.car_username = this.addForm.car_username;
        }else{
          this.$message.error('请先选择个人/或者填写');return false;
        }
        console.log('setFeeData-form',this.addForm);
        console.log('setFeeData-item',item);
        this.feeDataList.push(item);
      },
      //删除数据
      deleteItem(index, row) {
        this.feeDataList.splice(index, 1);
        if(row.id)
          this.del(row)
        //删除接口
      },
      //添加还款记录open
      repaymentSubmitForm(formName) {

        this.$refs[formName].validate((valid) => {
          if (valid) {
            // alert('submit!');
            this.repaymentForm.pay_date = this.getTime2(this.repaymentForm.pay_date);
            const param = {
              company_id:sessionStorage.getItem('company_id'),
              access_token:sessionStorage.getItem('token'),
              repaymentForm:this.repaymentForm,
              fee_list_id:this.repaymentForm.fee_list_id
            }

            this.$axios.addFeeRepayment(param).then(res =>{
              if(res.code == 200){
                this.DataList();
                this.getRepayemntList();
                this.$message.success(res.msg);

              }else{
                this.$message.error(res.msg);
              }
            })


          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      uploadFile(file) {
        this.dialogVisible = true;
        this.file_url = URL.createObjectURL(file.raw);
        // console.log('uploadFile-file', this.file_url);

        let payFd = new FormData();
        payFd.append('file', file.raw);
        payFd.append('img_type', 5);
        const companyId = sessionStorage.getItem('company_id');
        const accessToken = sessionStorage.getItem('token');

        if (!companyId || !accessToken) {
          this.$message.error('无法获取公司ID或访问令牌，请确保已登录');
          return;
        }
        payFd.append('company_id', companyId);
        payFd.append('access_token', accessToken);
          this.$axios.carUploadImage(payFd).then(res => {
            if (res.code == 200) {
              this.repaymentForm.file_url = res.data.src;

              this.$message.success(res.msg);
              this.dialogVisible = false;
            }else{
              this.$message.error(res.msg);
            }
          }).catch(error => console.log('UploadImage-error',error));

      },


      delImg(){
        this.repaymentForm.file_url = '';
        this.file_url = '';
      },
      openWin(url) {
        var name;                           //网页名称，可为空;
        var iWidth = 500;                         //弹出窗口的宽度;
        var iHeight = 570;                        //弹出窗口的高度;
        //window.screen.height获得屏幕的高，window.screen.width获得屏幕的宽
        var iTop = (window.screen.height - 30 - iHeight) / 2;       //获得窗口的垂直位置;
        var iLeft = (window.screen.width - 10 - iWidth) / 2;        //获得窗口的水平位置;
        window.open(url, name, 'height=' + iHeight + ',innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',toolbar=no,menubar=no,scrollbars=auto,resizable=no,location=no,status=no');
      },
      //添加还款记录end
      //支持导出图片和类型转换
      toExcel() {
        const column = [
          {
            title: 'ID',
            key: 'plate_number',
            type: 'text'
          },
          {
            title: '车牌号码',
            key: 'plate_number',
            type: 'text'
          },
          {
            title: '保险名称',
            key: 'product_name',
            type: 'text'
          },
          {
            title: '保司',
            key: 'corp_name',
            type: 'text'
          },

        ]

        // for(var i in this.tableLoadData){
        //   this.tableLoadData[i]['effective_date_format'] = this.getTime(this.tableLoadData[i]['effective_date'] * 1000);
        //   this.tableLoadData[i]['start_time_format'] = this.getTime(this.tableLoadData[i]['start_time'] * 1000);
        //   this.tableLoadData[i]['end_time_format'] = this.getTime(this.tableLoadData[i]['end_time'] * 1000);
        //   this.tableLoadData[i]['statusMsg'] = this.statusFilter2(this.tableLoadData[i]['status']);
        //   this.tableLoadData[i]['sourceMsg'] = this.tableLoadData[i]['source']? '运输公司':'平台';
        // }
        console.log('tableLoadData-excel',this.tableLoadData)
        table2excel(column, this.tableLoadData, '费用数据')
      },
      openRepayment(item) {
        this.feeDataList = item.fee_repayment;
        this.innerVisible = true;
        this.file_url = '';
        this.repaymentForm = {
          pay_type: '',
          pay_money: '',
          payee_account: '',
          payee_account_number: '',
          payee_bank: '',
          // payee_bank_name: '',
          pay_account: '',
          pay_account_number: '',
          pay_bank: '',
          // pay_bank_name: '',
          pay_date: new Date(),
          file_url:'',
        };
        this.repaymentForm.fee_list_id = item.id;

        console.log('openRepayment-fee_list_id',item.id);
      },
      handelDelRepay(e) {
        console.log('handelDelRepay-e',e);
        this.$confirm('此操作将删除该还款记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            id: e.id,
            type: 3,
          }
          //console.log(param);
          this.$axios.delFeeShopFee(param).then(res=>{
            if(res.code == 200){
              this.$message.success(res.msg);
              this.DataList();
              this.getRepayemntList();

            }else{
              this.$message.error(res.msg);
            }
          }).catch(error=>{
            //console.log(error);
          })
        }).catch(() => {
          // 点击取消:不删除了
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
          this.DataList()
        });
        this.teamDialog = false
      },
      getShopFeeOptionList(type) {
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          type:type,
        }
        this.$axios.getShopFeeOptionList(param).then(res=>{
          if(res.code == 200){

            if(type == 1){
              this.jbrTypeList = res.data;
            }else if(type == 2){
              this.jbrxmTypeList = res.data;
            }else if(type == 3){
              this.feeTypeList = res.data;
            }else if(type == 4){
              this.carUserName = res.data;
            }else {
              this.$message.error(res.msg);
            }


          }else{
            this.$message.error(res.msg);
          }
        }).catch(error=>{
          //console.log(error);
        })
      },
      getRepayemntList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          fee_id: this.repaymentForm.fee_list_id
        }

        this.$axios.getRepaymentList(param).then(res=>{
          if(res.code == 200){
            this.feeDataList = res.data
          }
        }).catch(error=>{
          //console.log(error);
        })
      },
    },
  };
</script>
<style scoped lang="less">
/deep/.upload-demo {
  margin: 0;
}
/deep/.el-card__body , /deep/.el-main  {
  padding: 0px;
}
.box-card{
  width: 100%;
  margin: -20px auto;
  padding: 0px;
}
  .table_name{
    font-weight: bold;
    /* border: 1px solid #f00; */
  }
  .table_name:hover{
    color: #409EFF;
    cursor: pointer;
  }
  .centerText{
    text-align: center;

  }
  .fontStyle1{
    display: block;
    font-size:14px;
    color: #606266;
  }
  .fontStyle2,.fontStyle3{
    font-size:14px;
    color: #3a8ee6;
  }
  .fontStyle3{
    font-size:22px;
    color: #999;
    position: absolute;
    bottom: 1px;
    right: 1px;
  }
/deep/.el-upload-dragger {
  width: 360px;
  height: 130px;
}

.borderStyle{
  border: 5px solid #B0C4DE;
}
</style>



// WEBPACK FOOTER //
// src/view/fee/extrasFeeList.vue